/**
 * Turn string into regular expression (Pure, doesn't mutate given string)
 * @param string {string} - example: /^foo.*$/i
 * @returns {RegExp|undefined}
 */
export default function toRegExp (string) {
    if (typeof string !== 'string') return
    const parts = string.split('/')
    return new RegExp(parts[1], parts[2])
}
